import { Tag } from '@chakra-ui/react';
import * as React from 'react';

import { EUserRole } from '@/graphql-types/globalTypes';

export const OrganizationRole: React.FC<{ role: EUserRole }> = ({ role }) => {
  if (
    ![
      EUserRole.ORGANIZATION_PAGE_ADMIN,
      EUserRole.ORGANIZATION_ACCOUNT_OWNER,
    ].includes(role)
  ) {
    return null;
  }

  return (
    <Tag variant="solid" colorScheme="gray" size="sm">
      {
        {
          [EUserRole.ADMIN]: '',
          [EUserRole.MORGOTH]: '',
          [EUserRole.ORGANIZATION_ACCOUNT_OWNER]: 'Account Owner',
          [EUserRole.ORGANIZATION_PAGE_ADMIN]: 'Admin',
          [EUserRole.REGULAR_USER]: '',
        }[role]
      }
    </Tag>
  );
};
